import {create} from "zustand";

type ResidentHouseholdForbiddenPending = {
  message: string;
  forbiddenHouseholdId: number | null;
};

type ResidentHouseholdForbiddenPendingStore = {
  pending: ResidentHouseholdForbiddenPending | null;
  isRecovering: boolean;
  queuePending: (payload: ResidentHouseholdForbiddenPending) => void;
  setRecovering: (isRecovering: boolean) => void;
  clearPending: () => void;
};

export const useResidentHouseholdForbiddenPendingStore = create<ResidentHouseholdForbiddenPendingStore>(
  (set, get) => ({
    pending: null,
    isRecovering: false,

    queuePending: (payload) => {
      if (get().pending) return;
      set({pending: payload, isRecovering: false});
    },

    setRecovering: (isRecovering) => set({isRecovering}),

    clearPending: () => set({pending: null, isRecovering: false}),
  }),
);
